@import '../../theme/global.scss';

:host {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 8px;
  position: relative;

  @media (min-width: map-get($breakpoints, 'md')) {
    padding: 0;
  }


  &:hover .snap-close-button {
    background-color: var(--close-button-hover-background-color);
    color: var(--close-button-hover-color);
  }

  &:focus-visible {
    outline: none;

    .snap-close-button {
      background-color: transparent;
      border-color: var(--close-button-border-color);
    }
  }
}

.snap-close-button {
  border: 1px solid transparent;
  border-radius: 4px;
  color: var(--close-button-color);
  cursor: pointer;
  display: flex;
  padding: 3px;
  @include box-sizing;
  @include set-font;

  @media (min-width: map-get($breakpoints, 'md')) {
    padding: 1px;
  }
}
